module.exports = __webpack_public_path__ + "img/blade1.3c88bf0e.png";